import React from 'react';

import * as constants from '../../../utils/constants';
import ModalIcon from '../../../assets/image_modal_search_limit.svg';

const errorModalInfo = {
  icon: ModalIcon,
  title: 'No hemos encontrado tu seguro de Protección de Tarjetas',
  text: (
    <div>
      Si adquiriste tu seguro hace 3 días o menos, realiza tu solicitud de
      atención por siniestros &nbsp;
      <a
        href={constants.LINK_BBVA_SEGURO_TARJETAS}
        target="_blank"
        rel="noopener noreferrer"
      >
        aquí
      </a>
      .
    </div>
  ),
  btnText: 'Entendido',
};

const errorAlreadyRegisteredInfo = {
  icon: ModalIcon,
  title: 'Ya has registrado una solicitud de atención',
  text: (
    <div>
      <p>
        Si necesitas reportar otra cobertura que no incluiste, escribe al
        correo:
      </p>
      <p>
        siniestrosprotecciondetarjeta@bbva.com con el siguiente asunto: Nombres
        completos, DNI y fecha de siniestro. Detalla en el correo la cobertura
        solicitada y adjunta tus movimientos bancarios.
      </p>
    </div>
  ),
  btnText: 'Entendido',
};

const errorAlreadyRegisteredLetter = {
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        Ya completaste todos los documentos requeridos. El registro de tu siniestro está siendo revisado.
      </p>
    </div>
  ),
  btnText: 'Entendido',
};

const errorOtherUserRegistered = {
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        El número de registro no está asociado al número de documento o a la fecha del siniestro. Por favor, revisa e intenta de nuevo
      </p>
    </div>
  ),
  btnText: 'Entendido',
};

const errorSysDate = {
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        La fecha ingresada no cuadra con la fecha del sistema.
      </p>
    </div>
  ),
  btnText: 'Entendido',
};

const errorCaptcha = {
  icon: null,
  title: '',
  text: (
      <p>
        Uy, ocurrió un error, por favor inténtalo nuevamente.
      </p>
  ),
  btnText: 'Entendido',
};

const errorSinisterNotExits = {
  icon: null,
  title: '',
  text: (
    <div>
      <p>
        El número de registro que ingresaste no corresponde a una solicitud. Por favor, revisa e intenta de nuevo.
      </p>
    </div>
  ),
  btnText: 'Entendido',
};

export {
  errorModalInfo,
  errorAlreadyRegisteredInfo,
  errorAlreadyRegisteredLetter,
  errorOtherUserRegistered,
  errorSysDate,
  errorCaptcha,
  errorSinisterNotExits
};
